
<template>
  <div class="" >
    <div class="card-header border-0" >
      <div class="row align-items-center">
        <div class="col-md-3">
          <h3 class="mb-0" >
            Cash Movements
          </h3>
        </div>

        <!-- {{selectedRowKeys}}--{{selectedRows[0]}}
        <div v-if="selectedRowKeys != null && selectedRows[0].type == 'Cash Out'" class="col-md-9 text-right">
          <button type="button" class="btn btn-sm btn-primary" @click="viewLiquidation"> View Liquidation </button> 
        </div> -->
      </div>

      <!-- <hr class="my-3 no-gutters"> -->
      <br>

      <a-drawer v-if="drawerVisible" title="" :width="500" placement="right" @close="onClose" :visible="drawerVisible">
          <br>
          <h6 class="navbar-heading text-muted">LIQUIDATION</h6>

          <div v-if="liquidation.length == 0">
                <a-empty class='mt-5' :image-style="{height: '50px',}" >
                    <span slot="description"> No liquidation for the selected Cash Out ({{selectedRows[0].reference}}) </span>
                </a-empty>
          </div>
          <div v-else>
        
            <a-card style="width: 100%">
                <p>Reference #: {{liquidation[0].reference}}</p>
                <p>By: {{liquidation[0].user_name}}</p>
                <p>On: {{liquidation[0].formatted_date}}</p>
                <p>Return to Drawer: {{autoCashIn}}</p>
            </a-card>
            
            <br>
            <div v-for="(line, index) in liquidation[0].liquidation_lines" :key="index">
                <a-card style="width: 100%" size="small" :title="line.or_number">
                    <div class="row">
                        <a :href="line.photo_url" target="_blank"><a-avatar shape="square" :size="64" :src="line.photo_url" class="col=md-3 ml-2"/></a>
                        <div class="col-md-9">
                            <b>Amount:</b> {{line.amount}} <br>
                            <div v-if="line.remarks != undefined"><b>Remarks:</b> {{line.remarks}} <br></div>
                            <div v-if="line.purpose != undefined"><b>Purpose:</b> {{line.purpose.name}} <br></div>
                        </div>
                    </div>
                </a-card>
            </div>
          </div>
      </a-drawer>

      <div class="row align-items-center">
        <div class="col-md-3">
          <base-input label="Business Date">
            <a-date-picker v-model="filterDate" format="YYYY-MM-DD" placeholder="Business Date" style="width:100%"/>
          </base-input>
        </div>
        <div class="col-md-6">
          <base-input label="Type">
            <a-select  v-model="filterStatus" placeholder="Status" optionFilterProp="children" style="width: 100%">
              <a-select-option :value="0">All</a-select-option>
              <a-select-option :value="1"> Cash In </a-select-option>
              <a-select-option :value="2"> Cash Out </a-select-option>
            </a-select>
          </base-input>
        </div>
         <div class="col-md-3">
          <base-input label="Purpose">
              <a-select style="width: 100%" placeholder="Please select" optionFilterProp="children"  v-model="purposeFilter">
                  <a-select-option v-for="purpose in purposes" :key="purpose.name" :value="purpose.name">{{purpose.name}}</a-select-option>
              </a-select>
            <!-- <a-date-picker v-model="filterDate" format="YYYY-MM-DD" placeholder="Business Date" style="width:100%"/> -->
          </base-input>
        </div>
      </div>

    </div>

<!-- rowSelection={{type:'radio'}} -->
    <!--  -->
    <a-table :columns="optionColumns" :dataSource="posActivities"  bordered style="height: 100vh;">
        <small slot="expandedRowRender" slot-scope="record" style="margin: 0">
            Timestamp: {{record.formatted_date}} <br>
            Session ID: {{record.session_id}} <br>
            Shift ID: {{record.shift_id}} <br>
            Purpose: {{record.purpose}} 
        </small>
         <template slot="operation" slot-scope="text, record">
             <!-- {{record}} -->
             <div v-if="record.type == 'Cash Out'">
                 <center>
                  <button @click="viewLiquidation(record)" class='btn btn-sm btn-primary' type="primary">View Liquidation</button>
                 </center>
             </div>
         </template>
    </a-table>
   
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import HTTPRequest from '../../controllers/httpRequest.js'
import secureStorage from '../../controllers/secureStorage.js'
import axios from "axios";
import moment from 'moment';

export default {
    computed: {
        ...mapState(['serverType', 'endPoint'])
    },
    mounted: async function(){
        var siteId = secureStorage.getItem("defaultSiteId")
        var posActivities = await HTTPRequest.getRequest(this.endPoint + 'pos_activities?site_id=' + siteId + '&business_date=' + this.filterDate.format('YYYY-MM-DD') + '&status=' + this.filterStatus , null)
        this.posActivities = posActivities

        var purposes = await HTTPRequest.getRequest(this.endPoint + 'purposes?document_type_id=CM', null)
        this.purposes = purposes.data


    },
    data: function(){
        return {
            purposes: [],
            autoCashIn: 0,
            drawerVisible: false,
            selectedRowKeys: null,
            liquidation: [],
            selectedRows: [],
            filterDate: moment(),
            filterStatus: 0,
            purposeFilter: null,
            posActivities: [],
            optionColumns: [
              {
                title: 'Reference',
                dataIndex: 'reference',
              },
              {
                title: 'User Name',
                dataIndex: 'user_name',
              },
              {
                title: 'Type',
                dataIndex: 'type',
                scopedSlots: { customRender: 'type' },
              },
              {
                title: 'Amount',
                dataIndex: 'amount',
                width: "15%",
                align: 'right'
              },
              {
                title: 'Status',
                dataIndex: 'formatted_status',
                width: "15%"
              },
              {
                title: '',
                dataIndex: 'operation',
                scopedSlots: {
                  customRender: 'operation'
                },
              }
            ],
        }
    },
    methods: {
        async getCashMovements(){
            var siteId = secureStorage.getItem("defaultSiteId")
            var posActivities = await HTTPRequest.getRequest(this.endPoint + 'pos_activities?site_id=' + siteId + '&business_date=' + this.filterDate.format('YYYY-MM-DD') + '&status=' + this.filterStatus+ '&purpose=' + this.purposeFilter , null)
            this.posActivities = posActivities
            this.selectedRowKeys = null
            this.selectedRows = []
        },
        onChange(selectedRowKeys, selectedRows){
          console.log(`selectedRowKeys: ${selectedRowKeys}`, 'selectedRows: ', selectedRows);
          this.selectedRowKeys = selectedRowKeys;
          this.selectedRows = selectedRows.slice();
        },  
        async viewLiquidation(record){
            this.selectedRows.push(record)
            this.drawerVisible = true
            var posActivities = await HTTPRequest.getRequest(this.endPoint + 'pos_activities/get_liquidation?id=' + record.id , null)
            this.liquidation = posActivities
            var autoCashIn = await HTTPRequest.getRequest(this.endPoint + 'pos_activities?parent_activity_id=' + record.id , null)
            this.autoCashIn = autoCashIn[0].amount
        },
        onClose(){
            this.drawerVisible = false
            this.liquidation = []
            this.selectedRows = []
        }
    },
    watch:{
      filterDate: async function(){
        await this.getCashMovements();
      },
      filterStatus: async function(){
        await this.getCashMovements();
        if(this.filterStatus == 0){
          var purposes = await HTTPRequest.getRequest(this.endPoint + 'purposes?document_type_id=CM', null)
          this.purposes = purposes.data
        }else{
          var purposes = await HTTPRequest.getRequest(this.endPoint + 'purposes?document_type_id=' + parseInt(this.filterStatus) * -1, null)
          this.purposes = purposes.data
        }
      },
      purposeFilter:async function(){
        await this.getCashMovements();
      },
    },
}
</script>

<style>
    .selected2{
        background-color:  #EFF6FF;
        color: #2371CC;
    }
</style>